export default "__VITE_ASSET__DICjwC_h__"